import { render, staticRenderFns } from "./SliderItem.vue?vue&type=template&id=a0c03edc"
import script from "./SliderItem.vue?vue&type=script&lang=js"
export * from "./SliderItem.vue?vue&type=script&lang=js"
import style0 from "./SliderItem.vue?vue&type=style&index=0&id=a0c03edc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports